// src/data/programModules.js

const programModules = [
  {
    slug: "digital-marketing-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Fundamentals of Digital Marketing",
        content:
          "The module covers setting marketing objectives, conducting market and competitor research, understanding the marketing funnel and customer journey, identifying target audience segments, creating buyer personas, developing value propositions, key digital marketing terms and metrics, media types, digital marketing channels, selecting the right channel mix, and case studies for each channel.",
      },
      {
        moduleNumber: 2,
        heading: "SEO Fundamentals",
        content:
          "The module covers understanding SEO and Google updates, debunking SEO myths, ranking analysis, content optimization, technical SEO, off-page SEO, link building fundamentals, internal linking, backlink analysis, URL removal, common SEO mistakes, Google penalties, and using AI for keyword research, content structure, and meta descriptions.",
      },
      {
        moduleNumber: 3,
        heading: "Social Media Marketing",
        content:
          "Social Media Marketing: The module covers fundamentals of social media marketing, including B2C vs B2B content strategies, channel-specific strategies, AI-driven content marketing, understanding algorithms, social media metrics, case studies, content formats, and marketing on YouTube, LinkedIn, Instagram, and Twitter.",
      },
      {
        moduleNumber: 4,
        heading: "Persuasive Copywriting",
        content:
          "Persuasive Copywriting: The module covers crafting headlines and persuasive copy, using storytelling, optimizing copy for different audiences, setting and aligning landing page goals, improving page navigation, ideal landing page frameworks, analyzing and optimizing ads, testing variations, utilizing creative elements, setting up briefs, and building brand guidelines.",
      },
      {
        moduleNumber: 5,
        heading: "Marketing on Google",
        content:
          "Marketing on Google: The module covers setting up Google Webmaster Tools, understanding campaign types and structures, keyword match types, crafting search ads, bidding strategies, creating campaigns, tracking performance, audience types in Google Ads, display and discovery advertising, mastering YouTube video ads, UAC campaigns, and data-driven performance management.",
      },
      {
        moduleNumber: 6,
        heading: "Marketing On Facebook",
        content:
          "Marketing On Facebook: The module provides an overview of Facebook Ads, covering objectives, metrics, and the algorithm. It explores audience types, bid strategies, ad platforms, and placements, types of ads, account setup for scaling, ROAS calculation, performance analysis, ad automation, and tools for rule and creative automation, as well as email and omni-channel messaging.",
      },
      {
        moduleNumber: 7,
        heading: "Marketing on LinkedIn & other platforms",
        content:
          "Marketing on LinkedIn & other platforms: The module covers LinkedIn Ads, including ad types, account setup, audience targeting, and custom audiences. It delves into LinkedIn analytics, performance tracking, conversion tracking, retargeting, and ad targeting. It also explores programmatic advertising, alternative ad networks, Apple Search Ads, Amazon Ads optimization, and native advertising with platforms like Taboola, Outbrain, Yahoo, and Quora.",
      },
      {
        moduleNumber: 8,
        heading: "Conversion Tracking",
        content:
          "Conversion Tracking: The module emphasizes the importance of conversion tracking, covering cookies and FLOC, analytics, GA4 reporting, funnel analysis, cohort and user lifetime analysis, attribution, and Google Analytics setup. It also includes Microsoft Clarity, Hotjar, event implementation, GTM, Mixpanel, mobile app tracking, Segment essentials, and a Matomo demo.",
      },
      {
        moduleNumber: 9,
        heading: "Basics to Advanced CRO",
        content:
          "Basics to Advanced CRO: The module covers understanding conversions and the fundamentals of CRO, detailing the CRO process: Observe, Ideate, Test, Deploy. It dives into heuristic analysis, data collection, hypothesis formation, testing, decision making, and deployment. It includes best practices and a CRO checklist for download.",
      },
      {
        moduleNumber: 10,
        heading: "Media Planning",
        content:
          "Media Planning: The module covers the fundamentals of media planning, including setting media objectives and strategy, deciding between traditional and digital media, budget allocation, media buying methods, scheduling, evaluation metrics, KPIs, ad fraud, brand safety, and real-life case studies.",
      },
      {
        moduleNumber: 11,
        heading: "Dashboard",
        content:
          "Dashboard: The module introduces data visualization techniques, covering various chart types and representations. It includes an overview of Data Studio, its building blocks, data sources, and connectors, filtering data, and preparing a live dashboard with a real-time problem statement.",
      },
      {
        moduleNumber: 12,
        heading: "Attribution",
        content:
          "Attribution: The module explains the need for attribution, covering view-through and click-through, questions MTA can answer, various attribution models, creating and interpreting Google Analytics attribution projects, designing custom models for B2B and B2C, and the algorithms behind building an attribution tool.",
      },
      {
        moduleNumber: 13,
        heading: "Marketing Automation",
        content:
          "Marketing Automation: The module highlights the importance of email marketing, identifying key players, best practices, top tips, and essential metrics. It also explores WhatsApp marketing, its advantages and challenges, blending email and WhatsApp strategies, and includes a live case study with a dashboard walkthrough.",
      },
      {
        moduleNumber: 14,
        heading: "Capstone Project & Job Preparation",
        content:
          "Capstone Project & Job Preparation: The module guides applying digital marketing strategies for a brand, resume building, avoiding mistakes, mock interviews, job search tools, LinkedIn outreach, understanding recruiter perspectives, salary negotiation, reasons companies hire, adding value, and career growth essentials.",
      },
    ],
  },
  {
    slug: "performance-marketing-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Fundamentals of Performance Marketing",
        content:
          "The key elements of performance marketing, starting with the basics and identifying target audiences. It discusses choosing effective channels, learning from competitors, and applying tactics specifically for B2B and B2C markets. Additionally, it highlights crucial metrics to master in this field.",
      },
      {
        moduleNumber: 2,
        heading: "Value Proposition, Ad Copy/Creative and Tests",
        content:
          "The Module content components of effective advertising, focusing on message matching, ad copywriting, and creative design to enhance click-through and conversion rates. It covers audience segmentation, funnel creation, ad analysis, and value proposition frameworks, culminating in practical projects like designing ads and writing copy for one's business.",
      },
      {
        moduleNumber: 3,
        heading: "Advanced Conversion Tracking & event setup",
        content:
          "The module content covers essential aspects of digital analytics, including understanding conversion events, setting up tracking systems, and introducing major analytics platforms like Google Analytics, Google Tag Manager, Segment, Matomo, and Mixpanel. It also involves practical",
      },
      {
        moduleNumber: 4,
        heading: "Deep Dive into Facebook and Google Ads",
        content:
          "The Module content delves into foundational advertising across Facebook, Google, and programmatic platforms like DV 360 & Oracle Bluekai. It covers strategies for engaging cold, warm, and hot traffic, along with troubleshooting and scaling campaigns. Practical projects include setting up and reviewing ads on Facebook and Google, understanding keyword intent for B2C and B2B, and running initial experiments. It also provides an overview of awareness and acquisition channels, including deep dives into affiliate marketing, ad networks, and app campaigns. It contrasts programmatic and direct buying, and covers strategies for audience building, offer creation, and ad optimization. Practical projects include creating B2B and B2C media plans, an app marketing roadmap, and researching the programmatic stack.",
      },
      {
        moduleNumber: 5,
        heading: "Complete Media Planning and Buying",
        content:
          "The module content explores ad automation and attribution fundamentals, including various models and their pros and cons for B2B and B2C. It covers tools for automating budgets, bids, audiences, and creatives. Projects involve building a custom attribution model and deep diving into ad automation hacks. It provides career growth insights, including reasons companies hire, adding value, salary expectations and negotiation, recruiter perspectives, job switching, overcoming psychological biases, mid-life career crises, job search strategies, and resume building tips to highlight skills effectively.",
      },
      {
        moduleNumber: 6,
        heading: "Understanding Attribution & Automation",
        content:
          "The module content offers guidance for advancing a performance marketing career, focusing on self-assessment, negotiating performance bonuses, increasing salary by 30% within the same organization, managing appraisals, effective LinkedIn outreach, excelling in interviews, and networking for long-term growth.",
      },
    ],
  },
  {
    slug: "ui-ux-design-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Discovering Design",
        content:
          "Overview of design fundamentals and elements such as color, font, spacing, and more.",
      },
      {
        moduleNumber: 2,
        heading: "Introduction to UX Design",
        content:
          "Discover the significance of UX design in the product development process and distinguishing it from UI Design.",
      },
      {
        moduleNumber: 3,
        heading: "Understanding Users and User Research",
        content:
          "Learn effective user research techniques and their importance in driving design decisions.",
      },
      {
        moduleNumber: 4,
        heading: "User Interface Design for Digital Devices",
        content:
          "Dive into the fundamentals of UI design, focusing on creating intuitive and visually appealing interfaces for various digital devices, with an emphasis on mobile and web applications.",
      },
      {
        moduleNumber: 5,
        heading: "Design Thinking Stages of design",
        content: "Thinking: Empathize, Define, Ideate, Prototype, and Test.",
      },
      {
        moduleNumber: 6,
        heading: "Wireframing and Prototyping",
        content:
          "Tools and techniques for wireframing, the transition from low-fidelity to high-fidelity prototypes.",
      },
      {
        moduleNumber: 7,
        heading: "Interaction Design Principles",
        content:
          "Design Principles of interaction design, designing for different device responsive design.",
      },
      {
        moduleNumber: 8,
        heading: "Usability Principles Key",
        content:
          "Principles of usability in UX design, Jakob Nielsen’s Usability Heuristics.",
      },
      {
        moduleNumber: 9,
        heading: "Visual Design",
        content:
          "Visual Design with UX Importance of visual elements in UX, color theory, typography, and layout.",
      },
      {
        moduleNumber: 10,
        heading: "Motion Design",
        content:
          "Discover the principles of motion design and its impact on user experience. Learn to craft smooth, engaging animations and transitions that enhance the interactivity and visual appeal of digital interfaces.",
      },
      {
        moduleNumber: 11,
        heading: "UX Research",
        content:
          "Explore the core techniques and methodologies of UX research, including usability testing, user personas, and journey mapping, to gather insights that drive user-centered design decisions.",
      },
      {
        moduleNumber: 12,
        heading: "AI for Design",
        content:
          "Learn how artificial intelligence can be leveraged in UX/UI design to automate processes, enhance user experiences, and create adaptive interfaces that anticipate user needs.",
      },
      {
        moduleNumber: "13 & 14",
        heading: "Portfolio and Career Prep",
        content:
          "Prepare for a successful career in UX design with guidance on building a compelling portfolio, and understanding industry expectations to stand out as a top candidate.",
      },
      {
        moduleNumber: "15 & 16",
        heading: "Capstone Project",
        content:
          "Develop a portfolio-ready capstone project in the final two weeks. Solve a real-world design problem to refine and test your skills. Receive expert guidance and feedback from industry leaders.",
      },
    ],
  },
  {
    slug: "product-management-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Understanding Product Management",
        content:
          "The module covers the evolution and definitions of product management, detailing the roles, responsibilities, and factors influencing PMs, alongside archetypes. It also explores the product development lifecycle, team roles, functions, and the career trajectory of a product manager.",
      },
      {
        moduleNumber: 2,
        heading: "Foundational skills",
        content:
          "The module delves into essential thinking skills for problem-solving and decision-making, including structured, MECE, first principles, and higher-order thinking. It emphasizes the importance of creative, data-driven, and hypothesis-driven approaches to enhance analytical capabilities.",
      },
      {
        moduleNumber: 3,
        heading: "Problem discovery and Market understanding",
        content:
          "The module explores market analysis techniques including viability, sizing, and STP strategies, alongside user research methodologies ranging from qualitative to quantitative, and primary to secondary. It also covers the user interview process, from recruitment to synthesizing learnings and developing user personas.",
      },
      {
        moduleNumber: 4,
        heading: "Strategy framing",
        content:
          "The module covers comprehensive industry and market analysis using Porter's Five Forces and PESTEL, company assessments through SWOT, and strategic planning including vision, mission, and value chains. It details strategy formulation from corporate to product strategy highlighting competitive advantages, strategic alignment, and effective goal setting with SMART goals and OKRs.",
      },
      {
        moduleNumber: 5,
        heading: "Solution ideation",
        content:
          "The module explores product solutions, detailing the process from conceptualizing unique ideas to disruptive innovations, and delves into UI/UX design from wireframes to usability principles. It covers system design, modern tech trends, and essential success metrics, including AARRR and HEART frameworks, concluding with strategies for defining and balancing MVPs.",
      },
      {
        moduleNumber: 6,
        heading: "Solution execution",
        content:
          "The module covers the essentials of Product Requirement Documents (PRDs), including their definition, structure, and criteria for effectiveness. It explores Agile development methodologies, focusing on scrum practices, sprint ceremonies, and the Kano model. Additionally, it addresses meeting strategies, stakeholder management, and best practices for balancing shallow and deep work.",
      },
      {
        moduleNumber: 7,
        heading: "Launching and learning",
        content:
          "The module explores quality assurance processes, launch strategies, and cross-functional readiness for effective rollouts, including change management. It covers usability testing techniques like the Mom test, introduces A/B testing with a statistical focus, and delves into analytics platforms, emphasizing data management, visualization, and privacy compliance.",
      },
      {
        moduleNumber: 8,
        heading: "Interview prep",
        content:
          "The module delves into the recruitment process, focusing on resume building and developing a case study portfolio. It explores various case-based question types, product design, and strategy frameworks, providing examples and methods for tackling product case questions effectively.",
      },
    ],
  },
  {
    slug: "management-consulting-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Introduction to Consulting",
        content:
          "Gain insight into consulting careers, key skills, firm operations, industry trends, and pathways. Explore entry strategies, prominent firms, practice types, and a real-life case study.",
      },
      {
        moduleNumber: 2,
        heading: "Business and Data 101",
        content:
          "Master consulting fundamentals, build a toolkit, conduct research, analysis, and production. Learn Excel, AI tools, storytelling, project types, and tackle real-life case studies.",
      },
      {
        moduleNumber: 3,
        heading: "Key Consulting Concepts - Part 1",
        content:
          "Learn to apply consulting frameworks like McKinsey’s 7-Step, BCG and Bain’s models, MECE, issue trees, hypothesis building, and AI tools through practical projects.",
      },
      {
        moduleNumber: 4,
        heading: "Key Consulting Concepts - Part 2",
        content:
          "Apply consulting concepts like the Pareto Principle, BCG Growth Matrix, Gantt charts, and RACI matrices in real-world scenarios. Leverage AI, complete case studies, and projects.",
      },
      {
        moduleNumber: 5,
        heading: "Case Simulation Mastery",
        content:
          "Master live case simulations, analyze case studies, tackle MBB Case Projects independently, and excel in a two-day, team-based business strategy challenge.",
      },
      {
        moduleNumber: "6 & 7",
        heading: "Case Interview Preparation",
        content:
          "Develop foundational skills in problem-solving, quantitative analysis, guesstimates, and case interviews. Practice problem structuring, brainstorming, and case closing with examples and sample interviews.",
      },
      {
        moduleNumber: 8,
        heading: "Consulting Career & Fit interview Prep",
        content:
          "Understand consulting careers, required skills, and firm operations to make informed choices. Learn candidate attributes, hiring processes, CV enhancement, FIT interviews, and effective storytelling.",
      },
      {
        moduleNumber: 9,
        heading: "Business Analysis: Advanced Excel Mastery",
        content:
          "Master data handling, referencing, arithmetic functions, lookups, and nested IFs. Learn advanced date, text functions, data cleaning, visualization, and summarization with pivot tables, charts, and dashboards.",
      },
      {
        moduleNumber: 10,
        heading: "Business Analysis: SQL Part 1",
        content:
          "Learn MySQL basics, SQL commands, data types, DQL, operators, handling NULL values, using CASE WHEN THEN, group operations, and aggregate functions.",
      },
      {
        moduleNumber: 11,
        heading: "Business Analysis: SQL Part 2",
        content:
          "Master SQL constraints, joins, DDL, DML, functions, constructs, unions, intersects, and sub-queries for efficient database management and querying.",
      },
      {
        moduleNumber: 12,
        heading: "Business Analysis: PowerBi",
        content:
          "Learn Power BI setup, interface, data sources, and visualizations. Explore Power Query Editor, data modeling, filtering, DAX expressions, data customization, and publishing with Power BI Service.",
      },
      {
        moduleNumber: 13,
        heading: "AI for Consultants",
        content:
          "Explore ChatGPT for content creation and research. Generate business ideas, conduct market research, optimize sheets, sales, performance marketing, legal tasks, and finance, all using AI tools.",
      },
      {
        moduleNumber: 14,
        heading: "Finance for Consultants",
        content:
          "Learn financial statement analysis (BS, PL, CFS), ratio analysis, working capital, liquidity management, and build financial models in Excel. Understand valuation drivers like DCF, WACC, and leverage.",
      },
      {
        moduleNumber: 15,
        heading: "Communicate like a Consultant",
        content:
          "Explore Communication Styles Study Pyramid Principle Summarize vs Synthesize Practice Synthesis Skills Craft Elevator Pitch",
      },
    ],
  },
  {
    slug: "product-marketing-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Product Market Familiarization",
        content:
          "Master the fundamentals of product marketing with a deep dive into key frameworks, techniques, and industry nuances. This program covers essentials such as market research, positioning frameworks, messaging loops, GTM strategies, and the AARRR funnel, while also exploring team structures and the market mix model. You'll develop strong analytical and project management skills, enabling you to create impactful marketing roadmaps. The journey culminates in a thought-provoking project, If You Were A Product, where you'll identify your target market, craft positioning strategies, design sales collateral, and develop a go-to-market plan—combining self-reflection with strategic execution.",
      },
      {
        moduleNumber: 2,
        heading: "Product Marketing Metrics",
        content:
          "Master the art of product marketing metrics with this comprehensive module. Learn to measure, analyze, and strategically select the right metrics to optimize your marketing efforts. Discover how Product, Marketing, and Sales teams define success, explore critical product metrics, and understand the nuanced differences between OKRs, KPIs, and KRIs. Delve deeper into TMoS, SQLs, and PQLs to enhance decision-making. As a hands-on project, benchmark your organization’s metrics against industry standards, assign satisfaction scores, and establish actionable goals to drive improved performance analysis.",
      },
      {
        moduleNumber: 3,
        heading: " Product Building - Nailing the Product",
        content:
          "This program equips you with the skills to define your Target Market, craft compelling messages, and determine Product Requirements with a focus on creating an Ideal Customer Profile (ICP), market positioning, and achieving product-market fit. You’ll dive into topics like defining your ICP using data sources, applying Messaging WTP (Willingness To Pay) and Pricing Frameworks, and utilizing Feature Prioritization frameworks through competitor benchmarking and market research. Additionally, you’ll explore go-to-market strategies, user flows, and features, and learn to write a precise Product Requirements Document (PRD). The 5Cs Approach and SCAN (Sticky Custom Audience Network) method will also be covered. As part of the project, you’ll define your ICP, benchmark competitors, conduct customer interviews for WTP insights, and build a comprehensive PRD.",
      },
      {
        moduleNumber: 4,
        heading: "Demand Generation",
        content:
          "Master demand generation by learning how to create high-converting campaigns, craft effective storytelling, and apply analytical techniques to drive execution and feature adoption. The course covers critical frameworks for Go-To-Market (GTM) strategies, key demand generation steps in product marketing, revenue-based budgeting, ROI, and influencer management. It also includes campaign optimization strategies and success frameworks, with a case study on The Force Awakens Star Wars campaign. Through a hands-on project, you’ll dive into product marketing writing, receive peer feedback for improvement, and design Go-To-Market strategies using the CCEBT framework to build a strong foundation in practical marketing campaign execution.",
      },
      {
        moduleNumber: 5,
        heading: "Revenue Realisation - Making the cash flow in",
        content:
          "This program focuses on enhancing sales effectiveness by driving revenue realization through a deep understanding of key metrics, such as NPS calculations and win-loss analysis, while developing competitive intelligence. Topics covered include the significance of sales training, how to apply the ICE framework to various collateral types, approaches to win-loss analysis, writing impactful collaterals, pricing frameworks, and CRM integration insights. A case study on sales enablement at WWO is also included. The project involves building a range of sales collaterals—such as a 1-pager, 2-pager, competitor comparison, and datasheet—while also conducting a win-loss analysis to identify critical factors influencing sales success and areas for improvement.",
      },
      {
        moduleNumber: 6,
        heading: "Acing the game",
        content:
          "This program helps you develop essential marketing skills, including storytelling, data-driven marketing, and digital tool mastery, while gaining hands-on experience in customer engagement. You'll learn how to analyze customer data, use the ICE Framework for digital engagement and personalization, and create compelling content. The program also covers driving product messaging frameworks, product sales mapping with tools like Trello, Jira, or Monday, and understanding the Voice of Customer. Through a case study, you'll apply your knowledge of marketing moments and data analytics, crafting a compelling case study based on customer insights and demonstrating your ability to influence decision-making.",
      },
      {
        moduleNumber: 7,
        heading: " Bonus Week",
        content:
          "In this course, you'll gain a comprehensive understanding of a product marketer's role, including their daily activities, essential tools, and decision-making frameworks. You'll learn how to align marketing strategies with business goals, leverage tools, hacks, and cheat sheets for efficiency, and dive into customer analysis techniques to better understand your audience. The course also covers how to tackle everyday challenges product marketers face and how to set and achieve revenue goals, equipping you with the practical skills needed to excel in the field.",
      },
    ],
  },
  {
    slug: "workshops/chatgpt-workshop",
    modules: [
      {
        moduleNumber: 1,
        heading: "ChatGPT and 15+ AI tools",
        content:
          "Unlock the full potential of ChatGPT using the magic prompt formula to produce the most accurate, precise and reliable information at your fingertips.",
      },
      {
        moduleNumber: 2,
        heading: "Data Analysis and with ChatGPT",
        content:
          "Leverage ChatGPT's advanced data analysis capabilities to: Unearth actionable insights for refining market strategies and outperforming competitors. Dissect consumer sentiments and behavior, providing you a competitive edge in understanding market trends and customer preferences.",
      },
      {
        moduleNumber: 3,
        heading: " Content Creation with AI",
        content:
          "Implement AI-powered content generation tools to: automate repetitive tasks such as social media posts and email newsletters, freeing up time for strategic planning and creativity. personalize content based on your user demographics and behavior, enhancing engagement and conversion rate. identify trending topics and relevant industry news, enabling timely and relevant content creation that resonates with your audience..",
      },
      {
        moduleNumber: 4,
        heading: "AI Powered Powerpoint Presentations",
        content:
          "Analyse market trends without coding skills or statistical analysis. Leverage AI-driven data analysis platforms to extract actionable insights from large datasets, empowering you with informed decision-making in marketing strategy development.",
      },
      {
        moduleNumber: 5,
        heading: "Speed up Your Job Hunting",
        content:
          "Integrate AI-powered analytics tools into marketing presentations to: provide real-time data insights and dynamic visualizations, enhancing audience engagement and comprehension. optimize marketing spreadsheet data, identifying key performance indicators and forecasting future trends with accuracy. automate the creation of compelling narratives and visual elements to enhance storytelling and impact",
      },
      {
        moduleNumber: 6,
        heading: "Elevate Reading Abilities 10x instantly",
        content:
          "Explore ChatGPT API integration in: customer service chatbots to deliver personalised and contextually relevant responses, enhancing customer satisfaction and loyalty. social media management platforms to automate content creation and engagement, optimising marketing efforts across diverse channels. Learn all about ChatGPT's new vision capabilities where AI can now see, hear, and interpret data.",
      },
      {
        moduleNumber: 7,
        heading: " Build a Personal Brand with AI",
        content:
          "Utilize AI for: Identifying relevant job opportunities tailored to your skills and experience, streamlining the job hunting process. Resume optimisation and tailoring your application materials for specific job roles and industries, increasing your chances of success. personalised guidance and resources for skill development and career advancement in the marketing field.",
      },
         {
        moduleNumber: 8,
        heading: "Supercharge Email Skills 10x Instantly",
        content:
          "Explore how generative AI tools can: automate content creation tasks to produce high-quality content efficiently. crafting engaging content for personal branding efforts to enhance visibility and credibility in their respective fields.",
      },
            {
        moduleNumber: 9,
        heading: " Experience AI's Audio Video Wonders",
        content:
          "Utilize AI-powered tools and GPT 4.5 Turbo for: text summarisation to extract key insights quickly and efficiently. Dissect consumer sentiments and behavior, providing you a competitive edge in understanding market trends and customer preferences. localize marketing content for global audiences while maintaining linguistic nuances and authenticity.",
      },
    ],
  },
    {
    slug: "workshops/linkedin-growth",
    modules: [
      {
        moduleNumber: 1,
        heading: "The Powerful Client Sniper Technique",
        content:
          "Find your exact potential clients on LinkedIn without spending a dollar in ads.",
      },
      {
        moduleNumber: 2,
        heading: "The 100M Content Formula",
        content:
          "Step by step LinkedIn content writing syntax to drive 4X engagement.",
      },
      {
        moduleNumber: 3,
        heading: " Acceptance Rate Skyrocket Formula",
        content:
          "Learn strategies to connect with an A-list network and skyrocket your acceptance rate.",
      },
      {
        moduleNumber: 4,
        heading: "Unlocking the potential of AI for LinkedIn",
        content:
          "Learn 10+ AI tools to automate tasks and generate content ideas with 10X efficiency.",
      },
      {
        moduleNumber: 5,
        heading: "The 7-Touchpoint Outbound System",
        content:
          "Master the 7 touch points to nurture connections before even sending them your first message.",
      },
      {
        moduleNumber: 6,
        heading: "Million-Dollar Lead Generation Process",
        content:
          "Generated over 2,00,00,000 in revenue for me and my clients using this process.",
      },
      {
        moduleNumber: 7,
        heading: "Reverse engineering TG OPN technique",
        content:
          "Search and connect with the right open-wallet leads that are keen to work with you.",
      },
         {
        moduleNumber: 8,
        heading: "AI-Powered Profile Optimization",
        content:
          "Learn how to beat the best performing profile and rank on LinkedIn search by leveraging AI",
      }
    ],
  },
      {
    slug: "workshops/ai-for-consultants",
    modules: [
      {
        moduleNumber: 1,
        heading: "The 4-step Magic Prompt formula",
        content:
          "Unlock the full potential of ChatGPT using the magic prompt formula to produce the most accurate, precise, and reliable information at your fingertips.",
      },
      {
        moduleNumber: 2,
        heading: "AI-Enhanced Scenario Modeling",
        content:
          "Use ChatGPT for predictive analysis, improving strategy depth. Offer data-driven insights to boost client engagement and business impact.",
      },
      {
        moduleNumber: 3,
        heading: " Redefine Strategy with AI",
        content:
          "Learn how ChatGPT enhances strategic planning, offering you the skills to refine and elevate your strategy with advanced AI insight",
      },
      {
        moduleNumber: 4,
        heading: "Mastering Market Analysis",
        content:
          "Refine strategies with market insights. Analyze consumer behavior for competitive advantage in understanding market trends and preferences.",
      },
      {
        moduleNumber: 5,
        heading: "AI Efficiency in Consulting",
        content:
          "Gain actionable insights on integrating AI to save significant time, enhance your efficiency, and focus on high-impact consulting activities.",
      },
      {
        moduleNumber: 6,
        heading: "Data Analysis Made Easy",
        content:
          "Leverage AI-driven data analysis platforms to extract actionable insights from large datasets, empowering you with informed decision-making in strategy development.",
      },
      {
        moduleNumber: 7,
        heading: "Unlock Consulting Opportunities",
        content:
          "Use AI to find consulting projects, optimize proposals, and get personalized insights for professional development in the consulting industry.",
      },
     
    ],
  },
          {
    slug: "workshops/product-management",
    modules: [
      {
        moduleNumber: 1,
        heading: "Introduction to Product Management",
        content:
          "What is a Product? Understanding the Basics Defining, Product Management Scope and Importance The Role of a Product Manager: Key Responsibilities and Expectations",
      },
      {
        moduleNumber: 2,
        heading: "The Product Manager's Path",
        content:
          "Exploring Types of Product Managers, Mapping the Career Growth and Opportunities, Essential Skills needed for Product Management",
      },
      {
        moduleNumber: 3,
        heading: "Mastering Problem Solving as a PM",
        content:
          "Types of Problems Encountered by PMs, Strategic Approach to Problem Solving, Case Study Problem Solving in Action at Uber",
      },
      {
        moduleNumber: 4,
        heading: "Landing Your PM Role",
        content:
          "Demystifying the PM Recruitment Process, Crafting the Perfect PM Resume, Preparing for Common Interview Questions",
      },
      {
        moduleNumber: 5,
        heading: "Interactive Q&A Session",
        content:
          "Get personalized advice and answers to your burning questions in real-time.",
      },
    ],
  },
               {
    slug: "workshops/marketing-mastermind",
    modules: [
      {
        moduleNumber: 1,
        heading: "Your Personal AI MARKETING ASSISTANT That Works 24/7",
        content:
          "Create a Custom GPT that writes high-converting copy while you sleep!",
      },
      {
        moduleNumber: 2,
        heading: "The NO-CODE AUTOMATION BLUEPRINT That Saves 15+ Hours/Week",
        content:
          "Connect AI tools that automatically generate, schedule, and optimize your campaigns.",
      },
      {
        moduleNumber: 3,
        heading: "The VISUAL MARKETING MASTERY System:",
        content:
          "Create stunning images and videos using MidJourney and Runway ML (even with zero design skills).",
      },
      {
        moduleNumber: 4,
        heading: "The ONE-PERSON ARMY Marketing Blueprint:",
        content:
          "Build systems to single-handedly run campaigns that normally require 3-5 specialists.",
      },
      {
        moduleNumber: 5,
        heading: "The AI TOOL BLACK BOOK (35+ Cutting-Edge Tools):",
        content:
          "Get insider access to the FULL arsenal of AI marketing weapons beyond just ChatGPT.",
      },
        {
        moduleNumber: 6,
        heading: "The PERFECT PROMPT FORMULA For Guaranteed Results:",
        content:
          "Master our 5-part prompt structure that gets perfect results from any AI tool, every time.",
      },
      {
        moduleNumber: 7,
        heading: "The SET & FORGET Lead Generation System",
        content:
          "Build workflows that find, qualify, and nurture leads while you focus on strategy.",
      },
      {
        moduleNumber: 7,
        heading: "Your Custom 2025 AI MARKETING ROADMAP",
        content:
          "Get a personalized plan showing exactly which AI tools to implement for YOUR challenges.",
      },
    ],
  },
                            {
    slug: "workshops/business-mastermind",
    modules: [
      {
        moduleNumber: 1,
        heading: "Your Personal AI MARKETING ASSISTANT That Works 24/7",
        content:
          "Create a Custom GPT that writes high-converting copy while you sleep!",
      },
      {
        moduleNumber: 2,
        heading: "The NO-CODE AUTOMATION BLUEPRINT That Saves 15+ Hours/Week",
        content:
          "Connect AI tools that automatically generate, schedule, and optimize your campaigns.",
      },
      {
        moduleNumber: 3,
        heading: "The VISUAL MARKETING MASTERY System:",
        content:
          "Create stunning images and videos using MidJourney and Runway ML (even with zero design skills).",
      },
      {
        moduleNumber: 4,
        heading: "The ONE-PERSON ARMY Marketing Blueprint:",
        content:
          "Build systems to single-handedly run campaigns that normally require 3-5 specialists.",
      },
      {
        moduleNumber: 5,
        heading: "The AI TOOL BLACK BOOK (35+ Cutting-Edge Tools):",
        content:
          "Get insider access to the FULL arsenal of AI marketing weapons beyond just ChatGPT.",
      },
        {
        moduleNumber: 6,
        heading: "The PERFECT PROMPT FORMULA For Guaranteed Results:",
        content:
          "Master our 5-part prompt structure that gets perfect results from any AI tool, every time.",
      },
      {
        moduleNumber: 7,
        heading: "The SET & FORGET Lead Generation System",
        content:
          "Build workflows that find, qualify, and nurture leads while you focus on strategy.",
      },
      {
        moduleNumber: 7,
        heading: "Your Custom 2025 AI MARKETING ROADMAP",
        content:
          "Get a personalized plan showing exactly which AI tools to implement for YOUR challenges.",
      },
    ],
  },
];

export default programModules;
